import {
  //createSelector,
  createSlice,
} from '@reduxjs/toolkit';

const initialState = {
  idCustomer: 214,
  userId: 0,
  brandId: 1,
  idStore: 1,
  brandCode: 'Eden',
  firstname: '',
  lastname: '',
  companyNm: '',
  priceLev: '01', // Default price level
  receiveEmail: '',
  SPermit: '',
  email: '',
  tel: '',
  cellPhone: '',
  fax: '',
  zipcode: '',
  loginDt: '',
  recentViewItemsList: [],
};

export const slice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    initUserInfo: (state) => {
      state.idCustomer = 214;
      state.userId = 0;
      state.brandId = 1;
      state.idStore = 1;
      state.brandCode = 'Eden';
      state.firstname = '';
      state.lastname = '';
      state.companyNm = '';
      state.priceLev = '01'; // Default price level
      state.receiveEmail = '';
      state.SPermit = '';
      state.email = '';
      state.tel = '';
      state.cellPhone = '';
      state.fax = '';
      state.zipcode = '';
      state.recentViewItemsList = [];
    },
    setUserInfo: (state, action) => {
      if (action.payload.idCustomer) {
        state.idCustomer = action.payload.idCustomer;
      }
      if (action.payload.userId) {
        state.userId = action.payload.userId;
      }
      if (action.payload.brandId) {
        state.brandId = action.payload.brandId;
      }
      if (action.payload.idStore) {
        state.idStore = action.payload.idStore;
      }
      if (action.payload.firstname) {
        state.firstname = action.payload.firstname;
      }
      if (action.payload.lastname) {
        state.lastname = action.payload.lastname;
      }
      if (action.payload.companyNm) {
        state.companyNm = action.payload.companyNm;
      }
      // Always use price level "01" for all users
      console.log(
        'setUserInfo - Backend provided priceLev:',
        action.payload.priceLev,
      );
      state.priceLev = '01';
      console.log('setUserInfo - Setting priceLev to "01" (forced)');
      if (action.payload.receiveEmail) {
        state.receiveEmail = action.payload.receiveEmail;
      }
      if (action.payload.SPermit) {
        state.SPermit = action.payload.SPermit;
      }
      if (action.payload.email) {
        state.email = action.payload.email;
      }
      if (action.payload.tel) {
        state.tel = action.payload.tel;
      }
      if (action.payload.cellPhone) {
        state.cellPhone = action.payload.cellPhone;
      }
      if (action.payload.fax) {
        state.fax = action.payload.fax;
      }
      if (action.payload.zipcode) {
        state.zipcode = action.payload.zipcode;
      }
      if (action.payload.loginDt) {
        state.loginDt = action.payload.loginDt;
      }
      if (action.payload.recentViewItemsList) {
        state.recentViewItemsList = action.payload.recentViewItemsList;
      }
    },
    addRecentViewItem: (state, action) => {
      const newItem = action.payload;
      const exists = state.recentViewItemsList.some(
        (item) => item.idStyle === newItem.idStyle,
      );
      if (!exists) {
        state.recentViewItemsList.push(newItem);
      }
    },
  },
});

export const { setUserInfo, initUserInfo, addRecentViewItem } = slice.actions;
export default slice.reducer;
